import { Directive, Input, inject } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormControlService } from "../form-control.service";

@Directive({
})
export class ControlValueAccessorImpl<T extends any = any> implements ControlValueAccessor {

  protected _destroy = new Subject<void>();

  //@injects
  protected _formControlService = inject(FormControlService);
  //@injects

  readonly dataFieldSubject = this._formControlService.dataFieldSubject;
  readonly valueSubject = this._formControlService.valueSubject;
  readonly touchedSubject = this._formControlService.touchedSubject;

  @Input() get dataField() {
    return this.dataFieldSubject.value;
  }
  set dataField(value) {
    this.dataFieldSubject.next(value)
  }
  @Input() get value() {
    return this.valueSubject.value;
  }
  set value(newValue) {

    this.valueSubject.next(newValue)
  }


  private _disabled: boolean = false;
  get disabled() {
    return this._disabled
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }

  protected _value!: T
  protected _onTouched!: (touched: boolean) => any;
  protected _onChange!: (value: T) => any;


  writeValue(value: T): void {

    this._value = value;
    if (value === this.value) {
      return
    }


    this.valueSubject.next(value);
  }

  registerOnChange(onChange: any): void {

    this._onChange = onChange;
    this._onChange(this.valueSubject.value)

  }

  registerOnTouched(onTouched: any): void {

    this._onTouched = onTouched;
    this._onTouched(this.touchedSubject.value)
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }



  constructor() {

    this.valueSubject
      .pipe(takeUntil(this._destroy))
      .subscribe((value) => {
        if (!this._onChange) {
          return;
        }

        this._onChange(value)
      })

    this.touchedSubject
      .pipe(takeUntil(this._destroy))
      .subscribe((touched) => {
        if (!this._onTouched) {
          return;
        }
        this._onTouched(touched)
      })
  }



}
